import React, { Component } from 'react';
import { Button, Navbar, Nav, NavItem, NavDropdown, MenuItem, Container, InputGroup, FormControl, Row, Col } from 'react-bootstrap';
import Link from 'next/link';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import { Form } from 'react-bootstrap';
import { _searchData } from '../../utils/searchJson.js';
import JsCookies from 'js-cookie';
import { phoneNumber } from '../../utils/gtagAction.js';

export default class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchData: [],
            searchContainer: false,
            search: ''
        }
    }

    onChangeHandling = async(e) => {
        const name = e.target.name;
        const value = e.target.value;
        let mainData = await _searchData(this.props.location)
        let result = mainData.filter(o => o.name.toLowerCase().includes(value.toLowerCase()));
        this.setState({ searchData: result, [name]: value, searchContainer: true })
    }

    disableTheSearchBox = () => {
        this.setState({ searchData: [], search: '', searchContainer: false })
    }

    checkIssueName = (obj) => {
        if (obj.isIssue) {
            JsCookies.set('isssueFromSearch', JSON.stringify(obj));
        }
        if (obj.route == '/faq') {
            JsCookies.set('isFaq', JSON.stringify(obj));
            this.props.checkedBox != undefined && this.props.checkedBox(obj)
        }
        if(JsCookies.get('isssuePayload')){
            JsCookies.set('isssuePayload', JSON.stringify([]));
        }        
    }

    componentDidMount = () =>{
        var input = document.getElementById("onclick-id");
        if(input){
            input.addEventListener("keyup", function (event) {
                // Number 13 is the "Enter" key on the keyboard
                if (event.keyCode === 13) {
                    // Cancel the default action, if needed
                    event.preventDefault();
                    // Trigger the button element with a click
                    document.getElementById("mobile-hamberger-icon").click();
                }
            });
        }
    }

    render() {
        let { route, myroute, offers, isHome, blog } = this.props
        return (
            <div className="sticky-nav">
                <Container fluid={true} className="mobile-header-s">
                    <Navbar collapseOnSelect expand="lg" className="GadgetZippy-navbar mt-sm-3">
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" id="mobile-hamberger-icon" />
                        <div className="desktop logo-width-d">
                            <Link href="/" as="/">
                                <a>
                                    <img src={`${publicRuntimeConfig.staticFolder}/images/Logo-sm.svg`} alt="GadgetZippy.com iPhone Repair Shop Near Me" className={isHome == true ? "cursor-non-pointer" : "cursor-pointer"} />
                                </a>
                            </Link>
                        </div>
                        <div className="mobile mobile-width">
                            <Row>
                                <Col xs className="pr-0">
                                    <Link href="/" as="/">
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/Gadgetzippy-logo.svg`} alt="GadgetZippy.com iPhone Repair Shop Near Me" className="pl-sm-2 cum-icon" />
                                    </Link>
                                </Col>
                                <Col xs className="pl-0">
                                    <div className="float-right phone-box">
                                        <div onClick={()=>{ phoneNumber();}}>
                                            <img src={`${publicRuntimeConfig.staticFolder}/images/pin-m.png`} alt="Phone icon" className="pl-sm-1 location-icon mr-sm-2" onClick={this.props.handleOpen} />
                                            <a href="tel: +91 99126 99999" className="">
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/Phone-Icon-g.svg`} alt="Phone icon" className="pl-2" />
                                                <span className="pl-1 phone-number">99126 99999</span>
                                            </a>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="mr-auto"></Nav>
                            <Nav>
                                <Link href="/">
                                    <a>
                                        <div className={route == 'Home' ? "zippy-nav-items gadgetZippy" : "zippy-nav-items"}>Home</div>
                                    </a>
                                </Link>
                                <Link href="/aboutUs">
                                    <a>
                                        <div className={myroute ? "zippy-nav-items gadgetZippy" : "zippy-nav-items"}>Who we are</div>
                                    </a>
                                </Link>
                                {/* <Link href="/">
                                    <div className="zippy-nav-items">Why us?</div>
                                </Link> */}
                                {/* <Link href="/">
                                    <div className="zippy-nav-items">Happy Customers</div>
                                </Link> */}
                                <Link href="/offers">
                                    <a>
                                        <div className={offers ? "zippy-nav-items gadgetZippy" : "zippy-nav-items"}>Offers</div>
                                    </a>
                                </Link>
                                
                                    <a href = "https://blog.gadgetzippy.com/" target = '_blank'>
                                        <div className={blog ? "zippy-nav-items gadgetZippy" : "zippy-nav-items"}>Blog</div>
                                    </a>
                                
                                {/* <Link href="/">
                                    <div className="zippy-nav-items">Get in Touch</div>
                                </Link> */}
                                <div>
                                    <div className="zippy-nav-items">
                                        <a href="tel: +91 99126 99999" className="">
                                            <div onClick={()=>{ phoneNumber();}}>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/Phone.svg`} alt="Phone icon" className="" />
                                                <span className="pl-1 gadgetZippy">99126 99999</span>
                                            </div>
                                        </a></div>
                                </div>
                                <div className="zippy-nav-items" onClick={this.props.handleOpen}>
                                    <img src={`${publicRuntimeConfig.staticFolder}/images/pin.png`} alt="pin" className="location-icon" />
                                    <span className="pl-1 ">{this.props.location}</span></div>
                                <div className="mt-2"></div>
                                <div className="Gadget-search">
                                    <Form.Control
                                        type="text"
                                        placeholder="Search"
                                        name="search"
                                        value={this.state.search}
                                        onChange={(event) => this.onChangeHandling(event)} />
                                    <img src={`${publicRuntimeConfig.staticFolder}/images/Search.svg`} alt="Search icon" className="search-icon" />
                                </div>
                            </Nav>
                        </Navbar.Collapse>
                    </Navbar>
                </Container>
                {this.state.searchContainer && <div className="custom-container-search" onClick={this.disableTheSearchBox}>
                    <div className="search-custom-box">
                        {this.state.searchData.map((res, index) => (
                            <Link href={res.route} as={res.asRoute} key={index}>
                                <div className="search-tex" id="onclick-id" onClick={() => this.checkIssueName(res)}>{res.name}</div>
                            </Link>
                        ))}
                        {this.state.searchData.length == 0 && <div className="search-tex">No result found</div>}
                    </div>
                </div>}
                <style jsx global>
                    {` @media only screen and (max-width: 810px){   
                        .collapsed .navbar-toggler-icon {
                            background-image: url('/static/images/Hambuger-menu-icon.png') !important;
                            background-repeat: no-repeat;
                            background-size: auto !important;
                        }      
                        .navbar-toggler-icon {
                            background-image: url('/static/images/hamberg-close.png') !important;
                            background-repeat: no-repeat;
                            background-size: 18px !important; 
                        }       
                    }
                    `}
                </style>
            </div>
        )
    }
}
